module.exports = __webpack_public_path__ + "static/media/img_ansatz_optimized.6ab5de54.jpg";